import {
  fetchGetApiIntroducerPortalIntroducerWhatsNew,
  fetchPostApiIntroducerPortalIntroducerWhatsNew,
} from '@iwoca/lapi-client/introducer_portal';

export const getWhatsNewContent = async (introducerId: string, pageNo = 1) => {
  const { data } = await fetchGetApiIntroducerPortalIntroducerWhatsNew({
    introducerId,
    query: {
      page_no: pageNo,
      per_page: 5,
    },
  });

  const { notifications, next_page, results, pages } = data;

  const notificationsWithIds = notifications.map((notification: any) => ({
    id: new Date(notification.created).getTime(),
    ...notification,
  }));

  return {
    data: notificationsWithIds,
    nextPage: next_page || undefined,
    total: results,
    pages,
  };
};

export const markAllWhatsNewContentAsRead = async (introducerId: string) => {
  return await fetchPostApiIntroducerPortalIntroducerWhatsNew({
    introducerId,
    body: {},
  });
};
